import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle2 } from 'lucide-react';
import axios from 'axios';
import { Modal } from './Modal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const inputCls = 'w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-[#7dd3fc]/50 transition-colors';

export const ResellerModal = ({ open, onClose }) => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', city: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const reset = () => {
    setForm({ name: '', email: '', phone: '', city: '' });
    setSent(false);
    setError('');
  };

  const handleClose = () => {
    onClose();
    setTimeout(reset, 300);
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/reseller`, form);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={sent ? 'Proposta Enviada!' : 'Seja um Revendedor'}
      subtitle={sent ? null : 'Preencha os dados e retornaremos em breve.'}
      testId="reseller-modal"
    >
      {sent ? (
        <div className="text-center py-4" data-testid="reseller-success">
          <CheckCircle2 size={56} className="text-[#7dd3fc] mx-auto mb-4" />
          <p className="text-white/70 mb-6">Recebemos sua proposta. Nossa equipe entrará em contato pelo e-mail ou telefone informado.</p>
          <button
            onClick={handleClose}
            className="px-6 py-2.5 bg-gradient-to-r from-[#7dd3fc] to-[#bae6fd] text-[#0a1628] font-bold rounded-xl"
          >
            Fechar
          </button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-300 text-sm">{error}</div>}
          <input required placeholder="Nome completo" value={form.name} onChange={change('name')} className={inputCls} data-testid="reseller-name-input" />
          <input required type="email" placeholder="E-mail" value={form.email} onChange={change('email')} className={inputCls} data-testid="reseller-email-input" />
          <input required placeholder="Telefone" value={form.phone} onChange={change('phone')} className={inputCls} data-testid="reseller-phone-input" />
          <input required placeholder="Cidade" value={form.city} onChange={change('city')} className={inputCls} data-testid="reseller-city-input" />
          <motion.button
            type="submit"
            disabled={loading}
            whileHover={{ scale: loading ? 1 : 1.02 }}
            whileTap={{ scale: loading ? 1 : 0.98 }}
            className="w-full py-3.5 bg-gradient-to-r from-[#7dd3fc] to-[#bae6fd] text-[#0a1628] font-bold rounded-xl shadow-lg shadow-[#7dd3fc]/30 flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="reseller-submit-btn"
          >
            <Send size={18} />
            <span>{loading ? 'Enviando...' : 'Enviar Proposta'}</span>
          </motion.button>
        </form>
      )}
    </Modal>
  );
};
